module.exports = __webpack_public_path__ + "static/media/icomoon.1e464847.eot";